<template>
  <span class="go-back">
    <a href="#" @click="goBack">< Voltar</a>
  </span>
</template>

<script>
    export default {
        methods: {
            goBack() {
                return this.$router.go(-1);
            }
        }
    };
</script>

<style scoped>
    .go-back {
        display: flex;
        cursor: pointer;
        position: absolute;
        left: 170px;
        height: 40px;
        border: solid 1px;
        width: 100px
    }

    button {
        border: 0;
        background-color: white;
    }

    a:link, a:visited, a:hover, a:active {
      text-decoration: none;
    }

    a {
      color: var(--q-color-primary) !important;
      transform: translate(45%, 20%);
    }

  .go-back:hover {
      height: 40px;
      background-color: var(--q-color-secondary) !important;
      border-radius: 30px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/GoBack.vue